import Pickr from "pickr-widget/dist/pickr.min.js";

/* @ngInject */
function pickr($filter) {
  return {
    restrict: "A",
    scope: {
      defaultValue: "<",
      opacity: "@",
      onChange: "&",
    },
    link: function (scope) {
      const pickr = new Pickr({
        el: ".color-picker",
        default: scope.defaultValue,
        showAlways: false,
        appendToBody: false,
        position: "right",
        components: {
          preview: true,
          opacity: scope.opacity || false,
          hue: true,
          output: {
            hex: true,
            rgba: false,
            hsla: false,
            hsva: false,
            cmyk: false,
            input: true,
            clear: false,
            save: true,
          },
        },
        onSave(hsva, instance) {
          if (
            instance.getColor().toHEX().toString().toLowerCase() !==
            scope.defaultValue.toLowerCase()
          ) {
            scope.onChange({ color: hsva.toHEX().toString() });
          }
        },
      });

      $(".pcr-save").val($filter("trans")("form.submit.save"));

      scope.$watch("defaultValue", (newVal, oldVal) => {
        if (newVal !== oldVal) {
          pickr.setColor(newVal);
        }
      });
    },
  };
}

export default pickr;
